import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'M12 19h.01', key: '1wutuc' }],
  ['path', { d: 'M12 3h.01', key: 'n36tog' }],
  ['path', { d: 'M16 19h.01', key: '1vcnzz' }],
  ['path', { d: 'M16 3h.01', key: 'll0zb8' }],
  ['path', { d: 'M2 13h.01', key: '1aptou' }],
  [
    'path',
    { d: 'M2 17v4.286a.71.71 0 0 0 1.212.502l2.202-2.202A2 2 0 0 1 6.828 19H8', key: '4cp7zq' },
  ],
  ['path', { d: 'M2 5a2 2 0 0 1 2-2', key: '1iztiu' }],
  ['path', { d: 'M2 9h.01', key: '1nzd1v' }],
  ['path', { d: 'M20 3a2 2 0 0 1 2 2', key: 'm48m3a' }],
  ['path', { d: 'M22 13h.01', key: 'ke7esy' }],
  ['path', { d: 'M22 17a2 2 0 0 1-2 2', key: '17q5fo' }],
  ['path', { d: 'M22 9h.01', key: 'npkp49' }],
  ['path', { d: 'M8 3h.01', key: '133hau' }],
];

/**
 * @component @name MessageSquareDashed
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMTloLjAxIiAvPgogIDxwYXRoIGQ9Ik0xMiAzaC4wMSIgLz4KICA8cGF0aCBkPSJNMTYgMTloLjAxIiAvPgogIDxwYXRoIGQ9Ik0xNiAzaC4wMSIgLz4KICA8cGF0aCBkPSJNMiAxM2guMDEiIC8+CiAgPHBhdGggZD0iTTIgMTd2NC4yODZhLjcxLjcxIDAgMCAwIDEuMjEyLjUwMmwyLjIwMi0yLjIwMkEyIDIgMCAwIDEgNi44MjggMTlIOCIgLz4KICA8cGF0aCBkPSJNMiA1YTIgMiAwIDAgMSAyLTIiIC8+CiAgPHBhdGggZD0iTTIgOWguMDEiIC8+CiAgPHBhdGggZD0iTTIwIDNhMiAyIDAgMCAxIDIgMiIgLz4KICA8cGF0aCBkPSJNMjIgMTNoLjAxIiAvPgogIDxwYXRoIGQ9Ik0yMiAxN2EyIDIgMCAwIDEtMiAyIiAvPgogIDxwYXRoIGQ9Ik0yMiA5aC4wMSIgLz4KICA8cGF0aCBkPSJNOCAzaC4wMSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/message-square-dashed
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MessageSquareDashed = createLucideIcon('message-square-dashed', __iconNode);

export default MessageSquareDashed;
